// 1
// import { ApolloClient } from 'apollo-client'
// import { HttpLink } from 'apollo-link-http'
// import { InMemoryCache } from 'apollo-cache-inmemory'
import Vue from 'vue'
import store from './store/store.js'
import * as VueGoogleMaps from 'vue2-google-maps'

// 2
// import VueApollo from 'vue-apollo'
import App from './App'
import router from './router'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAP_KEY,
    libraries: 'places'
  }
})

Vue.config.productionTip = false

// // 3
// const httpLink = new HttpLink({
//   // You should use an absolute URL here
//   uri: process.env.HASURA_URL
// })

// 4
// const authMiddleware = new ApolloLink((operation, forward) => {
// // add the authorization to the headers
//   operation.setContext({
//     headers: {
//       'x-hasura-admin-secret': process.env.HASURA_SECRET
//     }
//   })
//   return forward(operation)
// })

// const apolloClient = new ApolloClient({
//   link: httpLink, // link: concat(authMiddleware, httpLink),
//   cache: new InMemoryCache(),
//   connectToDevTools: true
// })
// // 5
// Vue.use(VueApollo)

// // 6
// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient,
//   defaultOptions: {
//     $loadingKey: 'loading'
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // 7
  // provide: apolloProvider.provide(),
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js